import {IMAGE_DEFAULT_FORMATS} from "../../../../../core/app/consts";
import {AssetsRequestParams} from "../../../../../infrastructure/models/params/assets-request-params";

export class BettingZoneMenuImageRequestParams extends AssetsRequestParams {
  constructor(id: String, width: Number,height: Number) {
    super(width, height);

    this.resourceName = this.resourceName + `/bettingZone/${id}`;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }


  get params(): * {
    return `${super.params},d_Website:AssetsSVGNewBrand:bettingZone:default.svg`;
  }
}
